import styled from 'styled-components';
import { Stack, Box, Typography } from '@mui/material';
import { c } from '../../../theme/colorUtils';

export const MaintenanceRoot = styled(Stack)`
  width: 100%;
  height: 100vh;
  background-color: ${c.textWhite};
  align-items: center;
  justify-content: flex-start;
  padding: 80px 32px;
  box-sizing: border-box;
  text-align: center;
  overflow-y: auto;
  @media (max-width: 550px) {
    padding: 32px 12px;
  }
`;

export const IllustrationWrapper = styled(Box)`
  width: 200px;
  height: 200px;
  margin-bottom: 40px;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const MainTitle = styled(Typography).attrs({
  variant: 'h5',
  fontWeight: 700,
  color: c.text01,
})``;

export const SecondaryTitle = styled(Typography).attrs({
  variant: 'h4',
  fontWeight: 700,
  color: '#C12B36',
  mb: 3,
})``;


export const DescriptionText = styled(Typography).attrs({
  variant: 'body1',
  marginBottom: 4,
  whiteSpace: 'pre-line',
})``;

export const ScheduleBox = styled(Stack).attrs({
  width: '100%',
  backgroundColor: '#F5F5F5',
  borderRadius: '16px',
  padding: '16px',
  alignItems: 'center',
  marginBottom: '32px',
  gap: 1,
  boxSizing: 'border-box',
})``;

export const ScheduleBadge = styled(Box).attrs({
  backgroundColor: '#C12B36',
  color: '#fff',
  padding: '4px 8px',
  borderRadius: '100px',
  fontSize: '14px',
})``;

export const ScheduleTimeText = styled(Typography).attrs({
  variant: 'body1',
  color: c.text01,
})``;

export const ScheduleNotice = styled(Typography).attrs({
  variant: 'caption',
  color: c.text02,
  fontWeight: 400,
})``;

export const InfoSection = styled(Stack).attrs({
  width: '100%',
  alignItems: 'center',
  gap: 1
})``;

export const InfoHighlight = styled(Typography).attrs({
  fontWeight: 700,
})`
  font-size: 1.125rem!important;
`;

export const InfoFooter = styled(Typography).attrs({
  variant: 'body2',
  whiteSpace: 'pre-line',
})``;
